import repository from "./SalaryPeriodRepository";
import CustomStore from "devextreme/data/custom_store";
import { useEffectOnce } from "react-use";
import { useState } from "react";
import safeAwait from "safe-await";
import DataGrid,{ Column, FilterRow,Editing,SearchPanel,Export } from "devextreme-react/data-grid";
//import DataGridView from "Component/DataGridView";
const SalaryPeriodPage = (props) => {
  // const [show, setShow] = useState(false);
  // const [message, setMessage] = useState("");
  const [store, setStore] = useState();
  const handleError = (error) => {
    // setShow(true);
    // setMessage(error.response.data.message);
    throw new Error("Network Error");
  };
  useEffectOnce(() => {
    const SalaryPeriodeStore = new CustomStore({
      key: "id",
      loadMode: "raw",
      load: async () => {
        const [error, data] = await safeAwait(repository.all());
        if (error) handleError(error);
        return data;
      },
      insert: async (values) => {
        const [error, data] = await safeAwait(repository.insert(values));
        if (error) handleError(error);
        return data;
      },
      update: async (key, values) => {
        const [error, data] = await safeAwait(repository.update(key, values));
        if (error) handleError(error);
        return data;
      },
      remove: async (key) => {
        const [error, data] = await safeAwait(repository.delete(key));
        if (error) handleError(error);
        return data;
      },
    });
    setStore(SalaryPeriodeStore);
  });
  return (
    <>
      <DataGrid
        dataSource={store}
        showBorders={true}
        useIcons={true}
        showEditorAlways={true}
        columnAutoWidth={true}
        activeStateEnabled={true}
      >
        <Editing
          mode={"form"}
          allowAdding={props.info.access.includes("new")}
          allowDeleting={props.info.access.includes("delete")}
          allowUpdating={props.info.access.includes("edit")}
          useIcons={true}
        />
        <Export enabled={true} />
        <SearchPanel visible={true} width="100%" />
        <FilterRow visible={true} />
        <Column
          dataField="date_from"
          dataType="date"
          format="dd MMM yy"
          caption="Dari"
        />

        <Column
          dataField="date_out"
          dataType="date"
          format="dd MMM yy"
          caption="Sampai"
        />
        {/* <Column
          dataField="id"
          caption="id"
          allowHiding={true}
          visible={false}
          allowEditing={false}
        /> */}
      </DataGrid>
    </>
  );
};
export default SalaryPeriodPage;
